import { Component } from '@angular/core';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { HeadingBlock } from './heading-block';
import { ContentModule } from '@tytapp/content';


@Component({
    selector: 'tyt-heading-block',
    standalone: true,
    imports: [ ContentModule ],
    template: `<h1>{{block.text}}</h1>`
})
export class ViewComponent extends ContentBlockViewComponent<HeadingBlock> {
}
